var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mobile-tab-list"},[_vm._t("tablist")],2),_c('div',{staticClass:"mobile-tab-content"},[_vm._t("tabcontent")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }